export default "__VITE_ASSET__CNJ0mnss__"